import React, { forwardRef } from 'react'

import { BorderLoader } from '../loaders/border-loader'
import * as S from './card.styled'

interface CardProps {
  children: React.ReactNode
  className?: string
  loading?: boolean
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ children, className, loading }, ref) => {
    return (
      <S.Card ref={ref} className={className}>
        {children}
        {loading && (
          <S.LoaderOverlay>
            <BorderLoader size="large" align="center" />
          </S.LoaderOverlay>
        )}
      </S.Card>
    )
  },
)
